import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { CapabilityPermissionService } from '@core/services/entities/capability-permission.service';
import { CapabilityPermissionResponseDto } from '@domain/capability-permission/dtos/capability-permission.response.dto';
import { GetCapabilityPermissionRequestDto } from '@domain/capability-permission/dtos/get-capability-permission.request.dto';
import { CapabilityPermissionRepository } from '@domain/capability-permission/repositories/capability-permission.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CapabilityPermissionRepositoryService
  implements CapabilityPermissionRepository
{
  constructor(
    private capabilityPermissionService: CapabilityPermissionService,
  ) {}
  get(
    request: GetCapabilityPermissionRequestDto,
  ): Observable<ApiResponse<CapabilityPermissionResponseDto[]>> {
    return this.capabilityPermissionService.get(request);
  }
}
